(function () {
  var HANDLE = 'shipping-protection';
  var variantId = null;
  var isAdding = false;

  fetch('/products/' + HANDLE + '.json')
    .then(function (r) { return r.json(); })
    .then(function (data) { variantId = data.product.variants[0].id; })
    .catch(function () {});

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = originalFetch.apply(this, arguments);

    if (!isAdding && url.indexOf('cart/add') !== -1) {
      promise.then(function (response) {
        if (!response.ok) return;
        response.clone().json().then(function (data) {
          // data is a single line item or {items:[...]} for multi-add
          var types = data.product_type !== undefined
            ? [data.product_type]
            : (data.items || []).map(function (i) { return i.product_type || ''; });
          if (!types.some(function (t) { return t === 'Education'; })) {
            addShippingProtection();
          }
        }).catch(function () {
          addShippingProtection();
        });
      }).catch(function () {});
    }

    return promise;
  };

  function addShippingProtection() {
    if (!variantId || isAdding) return;
    isAdding = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (i) { return i.handle === HANDLE; });
        if (inCart) { isAdding = false; return null; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      })
      .then(function (response) {
        isAdding = false;
        if (response && response.ok && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection' });
        }
      })
      .catch(function () { isAdding = false; });
  }
})();